
import Vue from 'vue';
import { Message } from 'element-ui';
export default{
  //提示
  openInfoTip(text){
    Vue.prototype.$tipid=Message({
      message:text || '请耐心等待，正在提交',
      type: 'info',
      duration:0
    });
  },
  //警告
  openWarningTip(text){
    Vue.prototype.$tipid=Message({
      message:text,
      type: 'warning',
      duration:0
    });
  },
   //关闭且成功提示
  closeTip(text){
    Vue.prototype.$tipid.close();
    Message({
      message:text || '操作成功',
      type: 'success',
      duration:1000
    });
  },
  //关闭提示
  closeMes(){
    Vue.prototype.$tipid.close();
  }
}







// WEBPACK FOOTER //
// ./src/utils/myfun.js